import React from 'react';
import { Badge } from './Badge';
import { Tooltip } from './Tooltip';
interface ExpenseStatusBadgeProps {
  status: 'pending' | 'approved' | 'rejected' | 'flagged';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  showTooltip?: boolean;
}
export function ExpenseStatusBadge({
  status,
  size = 'md',
  className = '',
  showTooltip = false
}: ExpenseStatusBadgeProps) {
  const statusVariant = {
    pending: 'warning',
    approved: 'success',
    rejected: 'danger',
    flagged: 'info'
  };
  const statusLabels = {
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    flagged: 'Flagged'
  };
  const tooltipContent = {
    pending: 'This expense is awaiting approval',
    approved: 'This expense has been approved',
    rejected: 'This expense has been rejected',
    flagged: 'This expense has been flagged for review'
  };
  const badge = <Badge variant={statusVariant[status] as any} size={size} className={className} withDot data-id="element-812">
      {statusLabels[status]}
    </Badge>;
  if (showTooltip) {
    return <Tooltip content={tooltipContent[status]} position="top" data-id="element-813">
        {badge}
      </Tooltip>;
  }
  return badge;
}